var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","loading":_vm.loading,"disabled":_vm.loading || !_vm.letterItem.diagnosFileName,"color":_vm.buttonColor},on:{"click":_vm.resendLetter}},[_vm._v(" "+_vm._s(_vm.letterItem.diagnosFileName ? 'Gensend udskrivningsbrev' : 'Pdf-filen mangler')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }